// =================================================================
// The Corrected and Production-Ready app.js File
// =================================================================

// --- PHASE 1: GLOBAL IMPORTS ---
// These libraries and styles are needed on almost every page.

// Import jQuery as an ES module for Vite-bundled plugins (like Bootstrap).
// It will link to the existing window.jQuery if available, or load its own.
import $ from 'jquery';
if (!window.jQuery) {
    window.jQuery = window.$ = $;
}

// Import all the global CSS libraries. Vite will bundle them.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'select2/dist/css/select2.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'sweetalert2/dist/sweetalert2.min.css';

import Swal from 'sweetalert2';
window.Swal = Swal;

import './offline-manager';

document.addEventListener('DOMContentLoaded', async () => {
    const dobInput = document.getElementById('dob');
    if (!dobInput) return;

    // حمّل JS + CSS في نفس الوقت (Code-splitting)
    const [{ default: flatpickr }, { Arabic }] = await Promise.all([
        import('flatpickr'),
        import('flatpickr/dist/l10n/ar.js'),
        import('flatpickr/dist/flatpickr.min.css'), // CSS يُحمَّل ديناميكيًا فقط هنا
    ]);

    flatpickr(dobInput, {
        locale: Arabic,
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd F Y',
        maxDate: 'today',
        minDate: '1900-01-01',
        monthSelectorType: 'dropdown',
        disableMobile: true,
        allowInput: true,
    });
});

// Import your own global/custom CSS files.
import '../css/style.css';
import '../css/master.css';
import '../css/app.css';


// Import all the global JavaScript libraries.
import './bootstrap.js'; // Laravel's bootstrap file (handles Echo, etc.)
import 'popper.js';
import 'bootstrap';

// Use dynamic imports for legacy plugins to ensure they run AFTER the global jQuery assignment above.
// ESM static imports (line 63) are hoisted and might run before line 11.
import('slick-carousel');
import('select2');
import('./vendor/notify.js');
import('./plugin.js'); // Your custom plugin initializations



document.addEventListener('DOMContentLoaded', function () {

    // --- Conditionally load JavaScript for specific pages ---
    if (document.querySelector('.tab2-content')) {
        import('./profile.js');
    }
    if (document.getElementById('all_rooms')) {
        import('./all_rooms.js');
    }
    if (document.getElementById('matches_page')) {
        // This will now work correctly in the built version.
        import('./matches.js');
    }
    if (document.getElementById('blogpost_page')) {
        import('./blogpost.js');
    }
    if (document.getElementById('showclient_page')) {
        import('./show_client.js');
    }
    if (document.getElementById('ticket_page')) {
        import('./ticket.js');
    }
    if (document.getElementById('upload-photo-registeration')) {
        import('./upload_photo_registeration.js');
    }
    if (document.getElementById('showchat_page')) {
        import('./chat.js');
    }
    if (document.getElementById('faq_page')) {
        import('./questions.js');
    }
    if (document.getElementById('phoneNumber') || document.getElementById('whatsappNumberInput')) {
        import('./verify-otp.js');
    }



}); // End of DOMContentLoaded listener

